/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_MinimizeInputs */



/**
* | output |
* | --- |
* | "Minimise" |
*
* @param {Meeting_Offline_MinimizeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_minimize = /** @type {((inputs?: Meeting_Offline_MinimizeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_MinimizeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Minimaliseren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réduire")
	return /** @type {LocalizedString} */ ("Minimise")
});